import { DEFAULT_PLAY_TERM } from '@playbooks/core/src/interfaces'

const PLAY_TERM_REPLACEMENT = '$PlayTerm'
const PLAY_SENDER_REPLACEMENT = '$Sender'

export default class StaticReplacementProcessor {
  replacementsMap = new Map<string, string>()

  constructor(playTerm: string, senderEmail: string) {
    this.replacementsMap.set(PLAY_TERM_REPLACEMENT, playTerm || DEFAULT_PLAY_TERM)
    this.replacementsMap.set(PLAY_SENDER_REPLACEMENT, senderEmail)
  }

  process(template: string) {
    let result = template
    for (const [key, value] of this.replacementsMap) {
      if (value) {
        result = result.replaceAll(key, value)
      }
    }
    return result
  }
}
